import ApiUtil from '../api/api.util'
import ApiConfig from '../api/api.config'
import EtnersParseUtil from './etners.parse.util'

// let VUEX_ALL_CMPY_CODE_MAP = {}
//
// if (sessionStorage.getItem('__VUEX_ALL_CMPY_CODE_MAP__') != null) {
//   VUEX_ALL_CMPY_CODE_MAP = JSON.parse(sessionStorage.getItem('__VUEX_ALL_CMPY_CODE_MAP__'))
//
// } else {
//   let allCodeUrl = 'http://localhost:8080//v1/ebmp/code/allCodesByCmpyCd.json'
//   let allCodeParam = {
//     'cmpyCd': ['00000'],
//   }
//
//   ApiUtil.post(allCodeUrl, allCodeParam).then(response => {
//     VUEX_ALL_CMPY_CODE_MAP = response.data.allCodeMap
//   })
// }
//
// let VUEX_ALL_SOL_CODE_MAP = {}
//
// if (sessionStorage.getItem('__VUEX_ALL_SOL_CODE_MAP__') != null) {
//   VUEX_ALL_SOL_CODE_MAP = JSON.parse(sessionStorage.getItem('__VUEX_ALL_SOL_CODE_MAP__'))
//
// } else {
//   let allSolCodeUrl = 'http://localhost:8080//v1/ebmp/code/allSolutionCodesBySolCd.json'
//   let allSolCodeParam = {
//     'solCd': ['1000'],
//   }
//
//   ApiUtil.post(allSolCodeUrl, allSolCodeParam).then(response => {
//     VUEX_ALL_SOL_CODE_MAP = response.data.allSolutionCodeMap
//   })
// }
//
// const getAllCompanyCodeMapUsingVuex = function (cmpyCd) {
//   if (cmpyCd == undefined) {
//     return VUEX_ALL_CMPY_CODE_MAP['00000']
//   } else {
//     return VUEX_ALL_CMPY_CODE_MAP[cmpyCd]
//   }
//
// }
//
// const getAllSolutionCodeMapUsingVuex = function (solCd) {
//   if (solCd == undefined) {
//     return VUEX_ALL_SOL_CODE_MAP['1000']
//   } else {
//     return VUEX_ALL_SOL_CODE_MAP[solCd]
//   }
//
// }

/*
 let COMMON_SOL_CD_MAP = []

 /!** init *!/
 if(sessionStorage.getItem('__DEFINE_SOL_CODE_MAP__') == null) {
 let solutionCodeUrl = 'http://localhost:8080//v1/ebmp/code/multiSolutionCodes.json`
 let solutionCodeParam = {
 "solutionCodes" : [
 { "cdGrup": "001", "solCd": "1000" },
 { "cdGrup": "003", "solCd": "1000" },
 { "cdGrup": "006", "solCd": "1000" }
 ]
 }

 ApiUtil.post(solutionCodeUrl, solutionCodeParam)
 .then(response => {
 let solutionCodeMap = response.data.solutionCodeMap;

 for(let cdGrup in solutionCodeMap) {
 let solCd = solutionCodeMap[cdGrup][0].solCd

 if(COMMON_SOL_CD_MAP[solCd] == undefined) {
 COMMON_SOL_CD_MAP[solCd] = { }
 }

 let commonSolCdMap = COMMON_SOL_CD_MAP[solCd]

 commonSolCdMap[cdGrup] = solutionCodeMap[cdGrup]
 }

 //2019년 3월 14일 현재 문제가 있으므로 세션에 저장하지 않음
 //sessionStorage.setItem('__DEFINE_SOL_CODE_MAP__', JSON.stringify(COMMON_SOL_CD_MAP))
 })
 } else {
 COMMON_SOL_CD_MAP = JSON.parse(sessionStorage.getItem('__DEFINE_SOL_CODE_MAP__'))
 }*/

/*let COMMON_CMPY_CODE_MAP = []

 if(sessionStorage.getItem('__DEFINE_CMPY_CODE_MAP__') == null) {
 let commonCodeUrl = 'http://localhost:8080//v1/ebmp/code/multiCommonCodes.json`
 let commonCodeParam = {
 "codes" : [
 { "cdGrup": "217", "cmpyCd": "00000" }
 ]
 }

 ApiUtil.post(commonCodeUrl, commonCodeParam)
 .then(response => {
 let codeMap = response.data.codeMap;

 for(let cdGrup in codeMap) {
 let cmpyCd = codeMap[cdGrup][0].cmpyCd

 if(COMMON_CMPY_CODE_MAP[cmpyCd] == undefined) {
 COMMON_CMPY_CODE_MAP[cmpyCd] = { }
 }

 let commonSolCdMap = COMMON_CMPY_CODE_MAP[cmpyCd]

 commonSolCdMap[cdGrup] = codeMap[cdGrup]
 }
 //2019년 3월 14일 현재 문제가 있으므로 세션에 저장하지 않음
 //sessionStorage.setItem('__DEFINE_CMPY_CODE_MAP__', JSON.stringify(COMMON_CMPY_CODE_MAP))
 })
 } else {
 COMMON_CMPY_CODE_MAP = JSON.parse(sessionStorage.getItem('__DEFINE_CMPY_CODE_MAP__'))
 }

 */

let VUEX_ALL_COMM_CODE_MAP = {}
if (sessionStorage.getItem('__VUEX_ALL_COMM_CODE_MAP__') != null&&sessionStorage.getItem('__VUEX_ALL_COMM_CODE_MAP__') !== undefined) {
  VUEX_ALL_COMM_CODE_MAP = JSON.parse(sessionStorage.getItem('__VUEX_ALL_COMM_CODE_MAP__'))
} else {
  let allCommCodeUrl = `${ApiConfig.platformDomain}/v1/ebmp/code/allCodesByCmpyCd.json`
  let allCommCodeParam = {
    'cmpyCd': ['00000'],
  }
  ApiUtil.post(allCommCodeUrl, allCommCodeParam).then(response => {
    VUEX_ALL_COMM_CODE_MAP = response.data.allCodeMap
    sessionStorage.setItem('__VUEX_ALL_COMM_CODE_MAP__', JSON.stringify(VUEX_ALL_COMM_CODE_MAP))
  })
}

const DEFAULT_CMPY_CD = '00000'
const DEFAULT_SOL_CD = '1000'

const getCodeIsMatched = function (option, codeMap) {

  if (codeMap[option.cdGrup] == undefined) {
    return null
  }

  let codeByCdGrupArray = codeMap[option.cdGrup]

  for (let i = 0; i < codeByCdGrupArray.length; i++) {
    let code = codeByCdGrupArray[i]

    if (code.cdNm == option.cdNm) {
      return code
    }
  }

  return null
}

const lookupSolutionCodeByCodeName = function (option) {
  if (COMMON_SOL_CD_MAP[option.solCd] == undefined) {
    return null
  } else {
    let codeMap = COMMON_SOL_CD_MAP[option.solCd]

    return getCodeIsMatched(option, codeMap)
  }
}

const getSolCdId = function (option) {
  option.type = 'scd' //scd or cd

  if (option.solCd == undefined) {
    option.solCd = DEFAULT_SOL_CD
  }

  if (option.cdGrup == undefined) {
    throw new Error('cdGrup 값은 필수입니다.')
  }

  if (option.cdNm == undefined) {
    throw new Error('cdNm 값은 필수입니다.')
  }

  return lookupSolutionCodeByCodeName(option) == null ? null : lookupSolutionCodeByCodeName(option).cdId
}

const getSolCdNameSpace = function (option) {
  option.type = 'scd' //scd or cd

  if (option.solCd == undefined) {
    option.solCd = DEFAULT_SOL_CD
  }

  if (option.cdGrup == undefined) {
    throw new Error('cdGrup 값은 필수입니다.')
  }

  if (option.cdNm == undefined) {
    throw new Error('cdNm 값은 필수입니다.')
  }

  return lookupSolutionCodeByCodeName(option) == null ? null : lookupSolutionCodeByCodeName(option).cdNameSpace
}

const lookupCompanyCodeByCodeName = function (option) {

  if (COMMON_CMPY_CODE_MAP[option.cmpyCd] == undefined) {
    return null

  } else {
    let codeMap = COMMON_CMPY_CODE_MAP[option.cmpyCd]

    return getCodeIsMatched(option, codeMap)
  }
}

const getCmpyCdId = function (option) {
  option.type = 'cd' //scd or cd

  if (option.cmpyCd == undefined) {
    option.cmpyCd = DEFAULT_CMPY_CD
  }

  if (option.cdGrup == undefined) {
    throw new Error('cdGrup 값은 필수입니다.')
  }

  if (option.cdNm == undefined) {
    throw new Error('cdNm 값은 필수입니다.')
  }

  return lookupSolutionCodeByCodeName(option) == null ? null : lookupSolutionCodeByCodeName(option).cdId
}

const getCmpyCdNameSpace = function (option) {
  option.type = 'cd' //scd or cd

  if (option.cmpyCd == undefined) {
    option.cmpyCd = DEFAULT_CMPY_CD
  }

  if (option.cdGrup == undefined) {
    throw new Error('cdGrup 값은 필수입니다.')
  }

  if (option.cdNm == undefined) {
    throw new Error('cdNm 값은 필수입니다.')
  }

  return lookupCompanyCodeByCodeName(option) == null ? null : lookupCompanyCodeByCodeName(option).cdNameSpace
}

const isNumber = (arg) => {
  // 문자열로 변환
  arg += ''

  // 좌우 공백 제거
  arg = arg.replace(/^\arg*|\arg*$/g, '')

  if (arg == '' || isNaN(arg)) {
    return false
  }

  return true
}

const getMatchType = (arg) => {
  if (arg === undefined || arg === null) {
    throw new Error('정의되지 않은 인자를 넣을 수 없습니다.')
  }

  let constructor = arg.constructor

  if (constructor == Number && this.isNumber(arg)) {
    return 'NUMBER'
  } else if (constructor == Object) {
    return 'OBJECT'
  } else if (constructor == String) {
    return 'STRING'
  } else if (constructor == Array) {
    return 'ARRAY'
  } else if (typeof arg === 'function') {
    return 'FUNCTION'
  } else {
    throw new Error('검증되지 않은 타입이 존재합니다.')
  }
}

const isEmpty = (arg) => {
  if (arg === undefined || arg === null || arg === 'null') {
    return true
  }

  let type = getMatchType(arg)

  let flag = false

  switch (type) {
    case 'NUMBER' :
      flag = false
      break
    case 'ARRAY' :
      flag = arg.length == 0
      break
    case 'STRING' :
      try {
        flag = arg.trim().length == 0
      } catch (e) {
        String.prototype.trim = function () {
          return this.replace(/^\s+|\s+$/g, '')
        }

        flag = arg.trim().length == 0
      }
      break
    case 'OBJECT' :
      try {
        flag = Object.keys(arg).length == 0
      } catch (e) {
        let count = 0

        for (let key in arg) {
          count++
        }

        flag = count == 0
      }
      break
  }

  return flag
}

const isNotEmpty = (arg) => {
  return !this.isEmpty(arg)
}

/**
 * 숫자 3자리마다 콤마(,)를 찍어서 리턴함.
 *
 */
const numberWithCommas = function (number) {
  const n = parseInt(number)

  if (isNaN(n)) {
    return number
  }

  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * 문자열에 콤마가 있는 경우 제거함.
 *
 */
const removeCommasInText = function (n) {
  if (typeof n == 'undefined' || n == null) {
    return 0
  }

  const txtNumber = '' + n
  return parseInt(txtNumber.replace(/(,)/g, ''))
}

/**
 * 텍스트에서 숫자만 추출해서 리턴함. 없으면 빈 문자열을 리턴
 *
 */
const extractOnlyNumbers = function (text) {
  if (text + '' == 'NaN') {
    return ''
  }

  switch (getMatchType(text)) {
    case 'STRING' :
      return text.replace(/[^0-9]/g, '')
    case 'NUMBER' :
      return text
    default :
      return ''
  }
}

const goSolutionUrl = function (solCd, solutionUrl, solGrup) {
  if (solutionUrl !== null) {
    if (solGrup == '10') {
      window.open(solutionUrl, solCd)
    } else {
      let lutk = sessionStorage.getItem('lutk')

      window.open(solutionUrl + '?loginUserToken=' + lutk)
    }
  } else {
    kendo.alert('  준비중입니다  ')

  }
}

const getAllCommonCodeMapUsingVuex = function () {
  return VUEX_ALL_COMM_CODE_MAP['00000']
}

const getAllSolutionMasterMapUsingVuex = function () {
  let VUEX_ALL_SOLUTION_MAP = {}
  if (sessionStorage.getItem('__VUEX_ALL_SOLUTION_MAP__') != null&&sessionStorage.getItem('__VUEX_ALL_SOLUTION_MAP__') !== undefined) {
    VUEX_ALL_SOLUTION_MAP = JSON.parse(sessionStorage.getItem('__VUEX_ALL_SOLUTION_MAP__'))
  } else {
    let allSolutionMapUrl = `${ApiConfig.platformDomain}/v1/ebmp/admin/solution/allSolutionMap.json`

    ApiUtil.post(allSolutionMapUrl).then(response => {
      if (response.data.resultStatus.messageCode === '2000') {
        VUEX_ALL_SOLUTION_MAP = response.data.resultData
        sessionStorage.setItem('__VUEX_ALL_SOLUTION_MAP__', JSON.stringify(VUEX_ALL_SOLUTION_MAP))
      }
    })

  }

  return VUEX_ALL_SOLUTION_MAP
}

const getAllMenuMasterMapUsingVuex = function () {

  let VUEX_ALL_MENU_MAP = {}
  if (sessionStorage.getItem('__VUEX_ALL_MENU_MAP__') != null&&sessionStorage.getItem('__VUEX_ALL_MENU_MAP__') !== undefined) {
    VUEX_ALL_MENU_MAP = JSON.parse(sessionStorage.getItem('__VUEX_ALL_MENU_MAP__'))
  } else {
    let allMenuMapUrl = `${ApiConfig.platformDomain}/v1/ebmp/admin/menu/list.json`
    const param = {
      loginUserToken: sessionStorage.lutk,
      skip: 0,
      take: 10,
      page: 1,
      pageSize: 10,
      requestType: 'EXPORT',
    }

    ApiUtil.post(allMenuMapUrl, param).then(response => {
      if (response.data.resultStatus.messageCode === '2000') {
        VUEX_ALL_MENU_MAP = response.data.resultData

        VUEX_ALL_MENU_MAP.forEach(menuData => {

          menuData.superMenuNm = menuData.superMenuId === null ? '' : EtnersParseUtil.superMenuIdToText(VUEX_ALL_MENU_MAP, menuData.superMenuId, menuData.menuMasterPK.solCd, menuData.menuMasterPK.wmGbn)

        })
        sessionStorage.setItem('__VUEX_ALL_MENU_MAP__', JSON.stringify(VUEX_ALL_MENU_MAP))
      }
    })
  }
  return VUEX_ALL_MENU_MAP

}

const cleanCacheRefreshSessionData = function () {
  sessionStorage.removeItem('__VUEX_ALL_SOLUTION_MAP__')
  sessionStorage.removeItem('__VUEX_ALL_MENU_MAP__')

    getAllSolutionMasterMapUsingVuex()
    getAllMenuMasterMapUsingVuex()

}


const sortArray = function (obj, sortColumn) {
  obj.sort(function (f, l) {

    // assuming distance is always a valid integer
    return parseInt(f[sortColumn], 10) - parseInt(l[sortColumn], 10)

  })
  return obj
}

export default {
  isNumber,
  getMatchType,
  isEmpty,
  isNotEmpty,
  extractOnlyNumbers,
  goSolutionUrl,
  getAllCommonCodeMapUsingVuex,
  getSolCdNameSpace,
  getSolCdId,
  getAllSolutionMasterMapUsingVuex,
  getAllMenuMasterMapUsingVuex,
  cleanCacheRefreshSessionData,
  sortArray
  /*  getCmpyCdNameSpace,
   getCmpyCdId,
   getAllCompanyCodeMapUsingVuex,*/
  // getAllSolutionCodeMapUsingVuex,
  /* numberWithCommas,
   removeCommasInText*/
}
